import { IconNames } from "/app/libraries/arcana/src/atoms/Icon/index.ts"


export const NotificationToastType = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
} as const
export type NotificationToastType =
  (typeof NotificationToastType)[keyof typeof NotificationToastType]

export interface INotificationToast {
  id: string
  message: string
  type?: NotificationToastType
  duration?: number
  icon?: IconNames
}

export interface ShowToastParams {
  message: string
  type?: NotificationToastType
  duration?: number
  icon?: IconNames
}

export const NOTIFICATION_TOAST_DURATION = 5000
